export default __webpack_public_path__ + "static/media/homepage.49ce13bf.mp4";